import { Component, OnInit, Input, ViewChild, Output, EventEmitter, ElementRef } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AuthService } from '../../../system/auth.service';
import { MovieService } from '../../../api/Services/maintenance/movie.service';
import { ToastrService } from 'ngx-toastr';
import { TabService } from '../../../tabconfig/tab.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { DialogService } from '../../../common/dialog.service';
import { FileUploader } from 'ng2-file-upload';
import { ModuleService } from '../../../api/Services/maintenance/module.service';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { BASE_URL_UPLOAD } from '../../../app.service';
import { FileViewerComponent } from '../../common/file-viewer/file-viewer.component';
import { MovieViewerVimeoComponent } from '../../common/movie-viewer-vimeo/movie-viewer-vimeo.component';


@Component({
  selector: 'app-movies',
  templateUrl: './movies.component.html',
  styleUrls: ['./movies.component.css']
})


export class MoviesComponent implements OnInit {
  @BlockUI() blockUI: NgBlockUI;
  message_loading: string;
  public parameters: any[];

  public ListContentCourses: any[];
  public loading: boolean;

  @Input() cou_in_id;
  @Input() moduleList: any;
  @Input() movieList: any[];
  @Input() default_select_module: number;
  @Input() cou_vc_uri_folder;

  public default_select_module_empty: string;
  public default_select_module_text: string;
  public editActivo = false;
  public displayedColumns: string[] = ['mov_vc_type', 'mov_vc_title', 'mov_in_order', 'opcion'];
  public dataSource = new MatTableDataSource<any[]>();



  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild('paginatorDatasource', { read: MatPaginator, static: true }) paginator: MatPaginator;

  ContentMovieCourses: FormGroup;


  uploader: FileUploader;

  public default_select_mov_in_type: string;

  bLink:Boolean = false;

  constructor(
    private authService: AuthService,
    private formBuilder: FormBuilder,
    private movieServices: MovieService,
    private toastr: ToastrService,
    private tabService: TabService,
    private dialog: MatDialog,
    private dialogService: DialogService,
    private moduleServices: ModuleService,
    private elementRef:ElementRef
  ) {
    this.message_loading = "Cargando...";


    this.uploader = new FileUploader({
      url: BASE_URL_UPLOAD,
      itemAlias: 'file',
      disableMultipart: false,
      autoUpload: false,
      method: 'post' //,
      //allowedFileType: ['image', 'pdf']
    });
    //  this.blockUI.start(this.message_loading); // Start blocking
    /*
       setTimeout(() => {
         this.blockUI.stop();
       }, 10000);
   */
  }

  ngOnInit(): void {
    this.LoadInitial();
    this.initForm();
    this.default_select_mov_in_type = '';
    this.default_select_module_empty = '';
    this.default_select_module_text = '';
    this.uploader.onAfterAddingFile = (file) => {
      console.log('Uploaded onAfterAddingFile:', file);
      file.withCredentials = false;
    };
    this.uploader.onCompleteItem = (item: any, status: any) => {
      debugger;
      console.log(JSON.parse(status));
      let obj = JSON.parse(status);
      if (obj["success"]) {
        let link = obj["data"]
        this.ContentMovieCourses.controls['mov_tx_link'].setValue(link.filename);
        this.ContentMovieCourses.controls['cou_vc_uri_folder'].setValue(this.cou_vc_uri_folder);

        if (this.editActivo == true) {
          this.update();
        }
        else {
          this.register();
        }

      }
    };

    console.log(this.movieList);
    this.dataSource = new MatTableDataSource<any[]>(this.movieList);
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }



  public initForm() {

    this.ContentMovieCourses = this.formBuilder.group({
      mov_bi_id: [null],
      mod_in_id: [null, Validators.required],
      emp_bi_id: [null],
      mov_in_type: [1, Validators.required],
      mov_vc_type: [null],
      mov_vc_title: [null, Validators.required],
      mov_tx_description: [null, Validators.required],
      mov_tx_link: [null],
      mov_in_order: [null, Validators.required],
      mov_bt_visible: [1],
      mov_in_status: [1],
      mov_vc_status: [null],
      cou_vc_uri_folder: [null],
      mod_vc_name: [null]
    });

  }
  public LoadInitial() {
    this.parameters = this.authService.getParameters();
  }

  public LoadModuleList() {
    let cou_in_id = this.cou_in_id;
    this.moduleServices.GetAll(cou_in_id).subscribe(
      data => {
        console.log(data)
        if (data['sucess']) {
          this.ListContentCourses = data["data"];
        }
        else {
          this.toastr.warning(data['msg'], 'Advertencia');
        }
      }
    );
  }

  public onChangeModuleMovie(value) {

    console.log(value);
    if (value != null) {

      if (value != '') {

        console.log('onChangeModuleMovie=>' + value);
        var cou_in_id = this.cou_in_id;
        this.default_select_module = value.target.value;
        this.default_select_module_text = value.target.options[value.target.options.selectedIndex].text;

        this.ContentMovieCourses.controls['mod_in_id'].setValue(value.target.value);
        this.ContentMovieCourses.controls['mod_vc_name'].setValue(this.default_select_module_text);

        this.loadMoviebyModuleID(cou_in_id,value.target.value);

      }
      else {
        this.dataSource = null;
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.default_select_module_text = '';
      }


    }




  }

  loadMoviebyModuleID(cou_in_id,value){
    this.blockUI.start(this.message_loading);
    this.movieServices.GetAll(cou_in_id, value).subscribe(
      data => {
        console.log(data)
        this.blockUI.stop();
        if (data['sucess']) {
          this.dataSource = new MatTableDataSource<any[]>(data["data"]);
          this.dataSource.sort = this.sort;
          this.dataSource.paginator = this.paginator;
        }
        else {
          this.toastr.warning(data['msg'], 'Advertencia');
        }

      }
    );
  }
  public LoadFile() {

    if (this.ContentMovieCourses.valid) {
      if (this.editActivo == true) {


        this.dialogService.openConfirmDialog('¿Seguro de modificar este registro?')
          .afterClosed().subscribe(res => {
            if (res) {

              if(this.bLink){
                this.ContentMovieCourses.controls['mov_tx_link'].setValue(this.ContentMovieCourses.controls['mov_tx_description'].value);

                this.update();
              }
              else{
               this.uploader.uploadAll()
              }
            }
          });
      }
      else {
        this.dialogService.openConfirmDialog('¿Seguro de guardar este registro?')
          .afterClosed().subscribe(res => {
            if (res) {
               if(this.bLink){
                this.ContentMovieCourses.controls['mov_tx_link'].setValue(this.ContentMovieCourses.controls['mov_tx_description'].value);
                this.register();
               }
               else{
                this.uploader.uploadAll()
               }


            }
          });
      }
    }


  }


  public register() {
    this.ContentMovieCourses.controls['emp_bi_id'].setValue(this.authService.getUserID());


    this.movieServices.Insert(this.ContentMovieCourses.getRawValue()).subscribe(
      data => {

        if (data['sucess']) {
          this.editActivo = false;
          let result = data['data'][0];
          let value_temp = this.default_select_module;
          this.ContentMovieCourses.controls['mov_bi_id'].setValue(result.ID);
          this.loadMoviebyModuleID(this.cou_in_id,this.default_select_module);
          this.ContentMovieCourses.reset();
          this.default_select_module = value_temp;
          this.ContentMovieCourses.controls['mod_in_id'].setValue(value_temp);
          this.ContentMovieCourses.controls['mod_vc_name'].setValue(this.default_select_module_text);
          this.toastr.success(data['msg'], 'Correcto');
        }
        else {
          this.toastr.warning(data['msg'], 'Advertencia');
        }
      }
    );
  }
  public edit(element) {
    console.log(element);
    this.editActivo = true;
    this.ContentMovieCourses.setValue(element);
  }
  public update() {
    this.movieServices.Update(this.ContentMovieCourses.getRawValue()).subscribe(
      data => {
        console.log(data);
        this.blockUI.stop();
        if (data['sucess']) {


          this.editActivo = false;
          let result = data['data'][0];
          let value_temp = this.default_select_module;
          this.ContentMovieCourses.controls['mov_bi_id'].setValue(result.ID);
          this.loadMoviebyModuleID(this.cou_in_id,this.default_select_module);
          this.ContentMovieCourses.reset();
          this.default_select_module = value_temp;
          this.default_select_mov_in_type = '';
          this.ContentMovieCourses.controls['mod_in_id'].setValue(value_temp);
          this.ContentMovieCourses.controls['mod_vc_name'].setValue(this.default_select_module_text);
          this.toastr.success(data['msg'], 'Correcto');

        }
        else {
          this.toastr.warning(data['msg'], 'Advertencia');
        }
      }
    );

  }
  public delete(element) {
    this.dialogService.openConfirmDialog('¿Seguro de eliminar este registro?')
      .afterClosed().subscribe(res => {

        if (res) {

          this.movieServices.Delete(element.mov_bi_id).subscribe(
            data => {
              console.log(data);

              if (data['sucess']) {
                this.editActivo = false;
                let result = data['data'][0];
                let value_temp = 0;
                this.ContentMovieCourses.controls['mov_bi_id'].setValue(result.ID);
                this.loadMoviebyModuleID(this.cou_in_id,this.default_select_module);
                value_temp = this.default_select_module
                console.log('delete => reset back => ' + this.default_select_module);
                this.ContentMovieCourses.reset();
                this.default_select_module = value_temp;
                this.ContentMovieCourses.controls['mod_in_id'].setValue(value_temp);
                console.log('delete => reset after => ' + this.default_select_module);
                this.toastr.success(data['msg'], 'Correcto');

              }
              else {
                this.toastr.warning(data['msg'], 'Advertencia');
              }
            }
          );
        }
      });
  }
  public cancel() {
    this.editActivo = false;
    let value_temp = this.default_select_module;
    this.ContentMovieCourses.reset();
    this.default_select_module = value_temp;
  }

  viewerFile(element) {
    const dialogConfig = new MatDialogConfig();

    if (element.mov_in_type == 1) {
      dialogConfig.disableClose = false;
      dialogConfig.autoFocus = true;
      dialogConfig.data = element.mov_vc_html;
      dialogConfig.minWidth = '40%';

      const dialogRef = this.dialog.open(MovieViewerVimeoComponent, dialogConfig);

      dialogRef.afterClosed().subscribe(result => {
        console.log(`Dialog result: ${result}`);
      });
    }
    else {

      if(element.mov_in_type==6){
        window.open(element.mov_tx_link, '_blank');
      }
      else{
        dialogConfig.disableClose = false;
        dialogConfig.autoFocus = true;
        dialogConfig.data = { action: 2, type:  element.mov_in_type, link: element.mov_tx_link } //element.mov_tx_link;

        dialogConfig.minWidth = '50%';

        const dialogRef = this.dialog.open(FileViewerComponent, dialogConfig);

        dialogRef.afterClosed().subscribe(result => {
          console.log(`Dialog result: ${result}`);
        });
      }

    }



  }

  onChange(value:number){

    if(value!=null){
      if(value>0){
         if(value==6){
           this.bLink = true;
         }
         else{
          this.bLink = false;
         }
      }
      else{
        this.bLink = false;
      }
    }
    else{
      this.bLink = false;
    }
  }
}
